import { NgModule } from '@angular/core';
import { SharedModule } from '../modules/shared.module';
import { AppMainComponent } from './/app.main.component';
import { AppMenuComponent } from './app.menu.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { AppBreadcrumbComponent } from './app.breadcrumb.component';
import { AppTopBarComponent } from './app.topbar.component';
import { AppFooterComponent } from './app.footer.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AppMainComponent, AppMenuComponent, AppMenuitemComponent, AppTopBarComponent, AppFooterComponent, AppBreadcrumbComponent, AppMenuitemComponent],
  imports: [SharedModule, RouterModule],
  exports: [AppMainComponent],
})
export class AppLayoutModule {}
